var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.inviteConfig.inviteEnable)?_c('invitation'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"users_list"},[_c('search-user'),_vm._v(" "),_c('favorite-users')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e69ccc6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/users/FavoriteUsersScreen.vue
// module id = null
// module chunks = 